import React from "react";
import Common from "./common";
import style from "css/lecture.module.css";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { useDispatch } from "react-redux";
import { openPopup } from "redux/slices/drawerPopupSlice";
import NeatPopup from "components/device/neat/neatPopup";

function Laboratory() {
  //dispatch
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const HeaderInfo = {
    subTitle: "Hybrid Smart Reserch Lab\n & Professor's Office",
    title: "하이브리드 스마트\n 연구실 / 교수실",
    info: [
      <font>
        물리적 실습과 온라인 실습을 결합한{"\n"} 하이브리드 학습 모델을 통해,{" "}
        <br />
        학생들은 언제 어디서나 실습에 참여할 수 있습니다. <br /> 이는 장소에
        구애받지 않고{"\n"} 유연하게 학습할 수 있는 환경을 제공합니다.
      </font>,
    ],
    img: "img/smartspace/labotoryImg1.png",
    img_m: "img/smartspace/labotoryImg1_m.png",
  };

  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                하이브리드 스마트 연구실/교수실은 AI 기반의 연구 장비를 통해
                뛰어난 연구 및 회의 경험을
              </font>
              <font>
                제공합니다. 다양한 기능을 통해 교수와 연구원 간의 상호작용을
                극대화합니다.
              </font>
            </>
          ) : (
            <>
              <font>
                하이브리드 스마트 연구실/교수실은 AI 기반의 연구 장비를 통해
                뛰어난 연구 및 회의 경험을 제공합니다. 다양한 기능을 통해 교수와
                연구원 간의 상호작용을 극대화합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "AI 화상 장비 ( AI remote learning device )",
      img: "img/smartspace/labotoryImg2.png",
      img_m: "img/smartspace/labotoryImg2_m.png",
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                사용자의 움직임을 실시간으로 추적하여, 카메라의 프레임을
                자동으로 조정합니다.
              </font>
              <font>
                이는 발표자가 일어서거나, 걸어다닐 때에도 항상 화면 중앙에
                위치하게 하여,
              </font>
              <font>시청자에게 최적의 시청 경험을 제공합니다.</font>
            </>
          ) : (
            <>
              <font>
                사용자의 움직임을 실시간으로 추적하여, 카메라의 프레임을
                자동으로 조정합니다. 이는 발표자가 일어서거나, 걸어다닐 때에도
                항상 화면 중앙에 위치하게 하여, 시청자에게 최적의 시청 경험을
                제공합니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "자유로운 움직임 포착",
      img: "img/smartspace/labotoryImg3.png",
      img_m: "img/smartspace/labotoryImg3_m.png",
    },
    {
      id: 3,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          {!isMobile && !isTablet ? (
            <>
              <font>
                최초의 세로형 AI 화상회의 장비는 컴팩트하고 경량화된 디자인으로,
              </font>
              <font>사용자가 손쉽게 이동할 수 있습니다.</font>
              <font>
                이는 사용자가 필요로 하는 곳에서 자유롭게 화상 회의를 설정할 수
                있도록 도와줍니다.
              </font>
            </>
          ) : (
            <>
              <font>
                최초의 세로형 AI 화상회의 장비는 컴팩트하고 경량화된 디자인으로,
                사용자가 손쉽게 이동할 수 있습니다. 이는 사용자가 필요로 하는
                곳에서 자유롭게 화상 회의를 설정할 수 있도록 도와줍니다.
              </font>
            </>
          )}
        </div>
      ),
      title: "이동 편의성",
      img: "img/smartspace/labotoryImg4.png",
      img_m: "img/smartspace/labotoryImg4_m.png",
    },
  ];

  const BodyFooter = [
    {
      id: 1,
      txt: "스마트 디바이스와 협업 도구를 활용하여 교수와 연구자들이 물리적 제약 없이 실시간으로 소통하고 자료를 공유할 수 있습니다.\n 이는 연구와 교육 과정의 생산성과 효율성을 크게 높입니다.",
      title: (
        <p>
          <font>연구 및 교육</font>의 효율성 향상
        </p>
      ),
    },
    {
      id: 2,
      txt: "하이브리드 환경을 통해 교수와 연구자는 언제 어디서나 연구를 진행할 수 있습니다. 이를 통해 연구 일정과 학습 활동을 보다 유연하게 조정할 수 있어 효율적인 시간 관리를 지원합니다.",
      title: (
        <p>
          <font>유연한 학술 및 연구</font> 환경 제공
        </p>
      ),
    },
    {
      id: 3,
      txt: "고급 디지털 장비와 실시간 협업 플랫폼을 활용해 교수와 학생, 또는 연구자들 간의 창의적인 아이디어 교류와 협력을 촉진합니다. 이는 다학제적 문제 해결과 혁신적 연구 결과를 도출하는 데 기여합니다.",
      title: <p>창의성과 협업 증진</p>,
    },
  ];
  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg2.png",
      title: "스마트 강의 컨트롤 시스템",
      txt: "스마트 강의 컨트롤 시스템은 강의실 내 장비와 디지털 콘텐츠를 통합\n관리하여, 교수와 학생 모두에게 최적화된 학습 환경을 제공합니다.\n실시간 강의, 화면 공유, 출석 관리 등을 손쉽게 운영할 수 있으며,\n하이브리드 수업에 효과적으로 대응할 수 있도록 설계되었습니다.",
      onClick: () => showDrawer("deviceone"),
    },
    {
      id: 2,
      img: "img/device/neat/swiper_board_pro.png",
      title: "화상회의 장비 neat. board Pro",
      txt: "Neat Board는 디지털 화이트보드와 화상회의 기능을 결합한 올인원 장비로, 강의실에서 실시간 협업과 몰입감 있는 강의를 지원합니다.",
      onClick: () => showDrawer("boardpro"),
    },
    {
      id: 3,
      img: "img/device/neat/swiper_board_50.png",
      title: "화상회의 장비 neat. board50",
      txt: "Neat Board 50는 소규모 및 중규모 강의실에 최적화된 올인원 디바이스로, 디지털 화이트보드와 고화질 화상회의 기능을 통해 생동감 있는 강의와 실시간 협업을 손쉽게 제공합니다.",
      onClick: () => showDrawer("board50"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };
  const BodyHeader = (
    <div className={style.bodyTitle}>
      <p>실습을 통한 실무 중심 교육</p>
      <p>
        실습 중심의{"\n"} 혁신적 학습 환경을 위한{"\n"} 하이브리드 스마트 실습실
      </p>
      <p>
        최첨단 장비와 기술을 활용한 실습 환경 <br /> 산업 전문가 및 기업 멘토의
        참여로 창의적이고 유연한 실습 가능
      </p>
    </div>
  );
  const BodyFooterTitle = (
    <div className={style.bodyFooterTitle}>
      <p>Riv Technology의{"\n"} 하이브리드 연구실/교수실 구축은</p>
      <p>
        <font>연구와 교육의 효율성을 높이고,</font>
      </p>
      <p>
        교수와 연구자들에게
        <font> 유연하고 창의적인{"\n"}</font>업무 환경을 제공합니다.
      </p>
    </div>
  );
  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      하이브리드 연구실 / 교수실{"\n"} <font>구성 환경</font>
    </div>
  );

  return (
    <>
      <SEOMeta
        title="하이브리드 스마트 연구실 / 교수실, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 하이브리드 스마트 연구실 / 교수실"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, 하이브리드 스마트 연구실 / 교수실"
      />
      <NeatPopup />
      <div>
        <Common
          headerInfo={HeaderInfo}
          bodyHeader={BodyHeader}
          bodyInfo={BodyInfo}
          bodyFooter={BodyFooter}
          compose={Compose}
          bodyFooterTitle={BodyFooterTitle}
          composeHeader={ComposeHeader}
        />
      </div>
    </>
  );
}

export default Laboratory;
